/* eslint-disable react/no-find-dom-node */
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { IState } from '../../store/index';

import * as styles from './index.css';

interface IRecaptchaOwnProps {
  sitekey?: string;
  theme?: 'dark' | 'light';
  type?: 'audio' | 'image';
  size?: 'compact' | 'normal';
  tabindex?: number;
  onValueChange(value: string | null): void;
}

interface IRecaptchaStoreProps {
  captchaSiteKey: string;
}

type IRecaptchaProps = IRecaptchaOwnProps & IRecaptchaStoreProps;

export class Recaptcha extends React.Component<IRecaptchaProps, {}> {
  public componentDidMount() {
    if (window.grecaptcha) {
      const container = findDOMNode(this) as HTMLDivElement;
      const { captchaSiteKey, theme, type, size, tabindex } = this.props;

      window.grecaptcha.render(container, {
        callback: this.handleRecapchaExecute,
        'expired-callback': this.handleRecapchaExpired,
        sitekey: captchaSiteKey,
        size,
        tabindex,
        theme,
        type,
      });
    }
  }

  public render() {
    return <div className={styles['recaptcha']} />;
  }

  private handleRecapchaExecute = (value: string) => {
    this.props.onValueChange(value);
  };

  private handleRecapchaExpired = () => {
    this.props.onValueChange(null);
  };
}

export const RecaptchaContainer = connect<IRecaptchaStoreProps>((state: IState) => ({
  captchaSiteKey: state.captchaSiteKey,
}))(Recaptcha);
